import {
  CustomLabel,
  FormTimesheetLabel
} from 'modules/timesheet-labels/labelSchema';

export const OFFSET_ENTRY = 'offset_entry';

export enum SPLIT_NOTE_FIELDS {
  SPLIT_ENTRIES = 'splitEntries',
  CLASSIFICATION = 'classification',
  TIMESHEET_LABELS = 'timesheetLabels',
  LABEL_VAL_INF_ID = 'labelValuesInferenceId',
  NOTE = 'description',
  START_TIME = 'startTime',
  END_TIME = 'endTime',
  DURATION = 'duration',
  CUSTOM_LABELS = 'customLabels'
}

export type SplitEntry = {
  id: string;
  name: string;
  weight: number;
  //key is being use by react-hook-form fieldArray
  key?: string;

  date: Date;
  startTime?: Date | null;
  endTime?: Date | null;
  duration?: number;
  description?: string;
  timesheetLabels?: FormTimesheetLabel[];
  labelValuesInferenceId?: string | null;
  newlyAddedOffsetEntry?: boolean;
  customLabels?: CustomLabel[];
};
